import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    label: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(19),
      fontWeight: theme.typography.fontWeightMedium,
      color: COLORS.neutral.blackBlue,
      paddingBottom: '0 !important',
    },
    input_root: {
      width: '100%',
      marginTop: theme.spacing(0.5),
    },
    input_input: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
    },
    error: {
      fontSize: theme.typography.pxToRem(13),
      lineHeight: theme.typography.pxToRem(20),
      marginTop: theme.spacing(0.5),
    },
  }),
  { name: 'FieldContentTaxonomy' }
);
